import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Page/Dashboard/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Login from "./Page/Authentication/Login";
import Forgotpassword from "./Page/Authentication/Forgotpassword";
import ResetPassword from "./Page/Authentication/ResetPassword";
import Layout from "./layout";
import RequireAuth from "./RequireAuth";
import Profile from "./Page/Profile/Profile";
import Slider from "./Page/Banner/Banner";
import AddSlider from "./Page/Banner/AddBanner";
import WebSetting from "./Page/Settings/WebSetting";
import Clients from "./Page/MasterTable/OurClient/Clients";
import AddClient from "./Page/MasterTable/OurClient/AddClient";
import Inquiries from "./Page/Inquiries/Inquiries";
import MileStone from "./Page/MasterTable/MileStone/MileStone";
import AddMilestone from "./Page/MasterTable/MileStone/AddMileStone";

import EmailConfiguration from "./Page/Settings/EmailConfiguration";
import FAQS from "./Page/MasterTable/FAQS/FAQS";
import CMS from "./Page/CMS/Cms";
import AddCms from "./Page/CMS/AddCms";
import AddFAQ from "./Page/MasterTable/FAQS/AddFAQ";
import PageBuilder from "./Page/PageBuilder/PageBuilder";
import AddPageBuilder from "./Page/PageBuilder/AddPageBuilder";
import Menu from "./Page/Menu/Menu";
import AddMenu from "./Page/Menu/AddMenu";
import AddSubMenu from "./Page/Menu/AddSubMenu";
import SubMenu from "./Page/Menu/SubMenu";
import UploadsFile from "./Page/uploads/UploadFile";
import PageBanner from "./Page/PageBanner/PageBanner";
import AddPageBanner from "./Page/PageBanner/AddPageBanner";
import InquiriesDetail from "./Page/Inquiries/InquiriesDetail";
import SocialMedia from "./Page/SocialMedia/SocialMedia";
import AddSocialMedia from "./Page/SocialMedia/AddSocialMedia";
import Teams from "./Page/MasterTable/Team/Teams";
import AddTeam from "./Page/MasterTable/Team/AddTeam";
import EmailTemplate from "./Page/Settings/EmailTemplate";
import AddEmailTemplate from "./Page/Settings/AddEmailTemplate";
import PageSection from "./Page/PageSection/PageSection";
import AddPageSection from "./Page/PageSection/AddPageSection";
import TrustBrand from "./Page/MasterTable/TrustBrand/TrustBrand";
import AddTrustBrand from "./Page/MasterTable/TrustBrand/AddTrustBrand";
import Services from "./Page/Service/Services";
import AddServices from "./Page/Service/AddServices";
import Testimonials from "./Page/MasterTable/Testimonials/Testimonials";
import AddTestimonial from "./Page/MasterTable/Testimonials/AddTestimonial";
import AmcPlan from "./Page/MasterTable/AMCPlan/AmcPlan";
import AddAmcPlan from "./Page/MasterTable/AMCPlan/AddAmcPlan";
import Modules from "./Page/MasterTable/Modules/Modules";
import AddModule from "./Page/MasterTable/Modules/AddModule";
import AddProject from "./Page/Projects/AddProject";
import Projects from "./Page/Projects/Projects";
import AddProjectGallery from "./Page/Projects/AddProjectGallery";
import ProjectGallery from "./Page/Projects/ProjectGallery";
import SeoSetting from "./Page/Settings/SeoSetting";
import Sitemap from "./Page/Settings/Sitemap";
import ClientType from "./Page/MasterTable/OurClient/ClientType";
import AddClientType from "./Page/MasterTable/OurClient/AddClientType";
import Category from "./Page/Category/Category";
import AddCategory from "./Page/Category/AddCategory";
import CategoryFeatures from "./Page/Category/CategoryFeatures";
import AddCategoryFeatures from "./Page/Category/AddCategoryFeatures";
import Features from "./Page/Features/Features";
import AddFeatures from "./Page/Features/AddFeatures";
import PageWiseFaqs from "./Page/MasterTable/PageWiseFaq/PageWiseFaqs";
import AddPageWiseFaq from "./Page/MasterTable/PageWiseFaq/AddPageWiseFaq";
import Subcategory from "./Page/Category/Subcategory";
import AddSubcategory from "./Page/Category/AddSubcategory";

function App() {
  let accessToken = localStorage.getItem("kyrusToken");
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={accessToken ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/forgot-password"
          element={
            accessToken ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Forgotpassword />
            )
          }
        />
        <Route
          path="/reset-password"
          element={
            accessToken ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <ResetPassword />
            )
          }
        />

        <Route
          path="*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/home-banners" element={<Slider />} />
                  <Route path="/add-home-banner" element={<AddSlider />} />
                  <Route path="/clients/:clientTypeId" element={<Clients />} />
                  <Route path="/add-client/:clientTypeId" element={<AddClient />} />

                  <Route path="/client-type" element={<ClientType />} />
                  <Route path="/add-client-type" element={<AddClientType />} />

                  <Route path="/brands" element={<TrustBrand />} />
                  <Route path="/add-brands" element={<AddTrustBrand />} />

                  <Route path="/amc-plans" element={<AmcPlan />} />
                  <Route path="/add-amc-plan" element={<AddAmcPlan />} />

                  <Route path="/modules" element={<Modules />} />
                  <Route path="/add-module" element={<AddModule />} />

                  <Route path="/category" element={<Category />} />
                  <Route path="/add-category" element={<AddCategory />} />

                  <Route path="/subcategory/:categoryId" element={<Subcategory />} />
                  <Route path="/add-subcategory/:categoryId" element={<AddSubcategory />} />

                  <Route path="/category-features/:categoryId" element={<CategoryFeatures />} />
                  <Route path="/add-category-feature/:categoryId" element={<AddCategoryFeatures />} />

                  <Route path="/features" element={<Features />} />
                  <Route path="/add-feature" element={<AddFeatures />} />

                  <Route path="/projects" element={<Projects />} />
                  <Route path="/add-project" element={<AddProject />} />

                  <Route path="/testimonials" element={<Testimonials />} />
                  <Route path="/add-testimonial" element={<AddTestimonial />} />

                  <Route path="/services" element={<Services />} />
                  <Route path="/add-service" element={<AddServices />} />

                  <Route path="/project-gallery/:projectId" element={<ProjectGallery />} />
                  <Route path="/add-project-gallery/:projectId" element={<AddProjectGallery />} />

                  <Route path="/milestones" element={<MileStone />} />
                  <Route path="/add-milestone" element={<AddMilestone />} />
                  <Route path="/website-setting" element={<WebSetting />} />

                  <Route path="/inquiries" element={<Inquiries />} />
                  <Route path="/inquiry-detail" element={<InquiriesDetail />} />

                  <Route path="/teams" element={<Teams />} />
                  <Route path="/add-team" element={<AddTeam />} />

                  <Route path="/social-media" element={<SocialMedia />} />
                  <Route
                    path="/add-social-media"
                    element={<AddSocialMedia />}
                  />
                  <Route
                    path="/email-configuration"
                    element={<EmailConfiguration />}
                  />
                  <Route path="/pagewise-faq" element={<PageWiseFaqs />} />
                  <Route path="/add-pagewise-faq" element={<AddPageWiseFaq />} />

                  <Route path="/faqs" element={<FAQS />} />
                  <Route path="/add-faq" element={<AddFAQ />} />

                  <Route
                    path="/page-section/:pageId"
                    element={<PageSection />}
                  />
                  <Route
                    path="/add-page-section/:pageId"
                    element={<AddPageSection />}
                  />

                  <Route path="/cms" element={<CMS />} />
                  <Route path="/add-cms" element={<AddCms />} />


                  <Route path="/page-builder" element={<PageBuilder />} />
                  <Route
                    path="/add-page-builder"
                    element={<AddPageBuilder />}
                  />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/add-menu" element={<AddMenu />} />
                  <Route path="/submenu/:menuId" element={<SubMenu />} />
                  <Route path="/add-submenu/:menuId" element={<AddSubMenu />} />
                  <Route path="/upload-file" element={<UploadsFile />} />
                  <Route path="/page-banners" element={<PageBanner />} />
                  <Route path="/add-page-banner" element={<AddPageBanner />} />
                  <Route path="/sitemap" element={<Sitemap />} />
                  <Route path="/seo" element={<SeoSetting />} />
                  <Route path="/email-template" element={<EmailTemplate />} />
                  <Route
                    path="/add-email-template"
                    element={<AddEmailTemplate />}
                  />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
      <ToastContainer autoClose={1000} />
    </Router>
  );
}

export default App;
